import React, { useState } from "react";
import { pageTitle } from "../PageTitle";
import { Link } from "react-router-dom";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import Pricingbanner from "./../../assets/images/banner/pricing.png";


const Pricing = () => {
  pageTitle("Pricing");

  const savingsData = {
    low: {
      label: "Essentials",
      annual: "$18,000",
      monthly: "≈ $1,500/month manual effort saved",
      desc: "Estimated for a smaller support volume with basic WhatsApp automation.",
    },
    medium: {
      label: "Pro",
      annual: "$30,000",
      monthly: "≈ $3,000/month manual effort saved",
      desc: "Estimated for a growing team where AI handles regular customer conversations.",
    },
    high: {
      label: "Custom",
      annual: "$48,000",
      monthly: "≈ $4,000/month manual effort saved",
      desc: "Estimated for higher message volume with more repetitive support workload automated.",
    },
  };

  const [activeSaving, setActiveSaving] = useState("medium");
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  const pricingData = [
    {
      id: 1,
      planName: "ESSENTIALS",
      oldPrice: "$2,400",
      amount: "$1,200/yr",
      monthly: "$100/mo*",
      bestFor: "BEST FOR: WHATSAPP",
      title: "One channel. One workflow. Live today.",
      features: [
        "AI agent for WhatsApp",
        "Connect with 100 existing customers",
        "Trained on your business context",
        "Customer enquiry automation",
        "Basic reporting dashboard",
      ],
      delay: "100ms",
    },
    {
      id: 2,
      planName: "PRO",
      oldPrice: "$3,600",
      amount: "$1,800/yr",
      monthly: "$150/mo*",
      bestFor: "BEST FOR: WHATSAPP + AI CRM",
      title: "Sales and support in one AI CRM",
      features: [
        "AI agent for WhatsApp",
        "Connect with 100 existing customers",
        "AI-native CRM with auto-labels",
        "Advanced customer tracking",
        "Email channel available",
      ],
      delay: "200ms",
    },
    {
      id: 3,
      planName: "CUSTOM",
      oldPrice: "$4,800",
      amount: "$2,400/yr",
      monthly: "$200/mo*",
      bestFor: "BEST FOR: PRO + INTEGRATIONS",
      title: "Connect your AI CRM to key tools.",
      features: [
        "Custom AI agent for WhatsApp",
        "Connect with 100 existing customers",
        "Up to 3 standard integrations",
        "AI-native CRM with ticketing",
        "Email channel available",
      ],
      delay: "300ms",
    },
  ];
  const faqs = [
    {
      q: "What is included in each pricing plan?",
      a: "Each plan includes an AI WhatsApp agent, business-specific setup, automation support, and the features listed under that plan. Higher plans include more advanced CRM, email, and integration options.",
    },
    {
      q: "Is there a minimum contract period?",
      a: "Yes. All pricing plans require a minimum 12-month contract.",
    },
    {
      q: "What types of messages can I send with the API?",
      a: "You can send pre-approved templated messages for notifications, alerts, and verifications, as well as support two-way conversations with customers for service and support.",
    },
    {
      q: "Can the AI solution be customized for my business?",
      a: "Yes. The AI agent can be trained and configured based on your business process, customer questions, workflow, and required automation features.",
    },
    {
      q: "Do you offer custom pricing?",
      a: "Yes. Custom pricing is available for businesses that need higher usage limits, advanced workflows, multiple integrations, or tailored AI automation features.",
    },
  ];

  return (
    <>
      <HeaderOne />
      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${Pricingbanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-text">
            <h2 className="ai-overlay-project">Pricing</h2>
          </div>
        </div>
      </div>

      <section className="siw-pricing-hex-page p_relative">
        <div className="auto-container">
          <div className="row justify-content-center">
            {pricingData.map((item) => (
              <div
                className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated"
                data-wow-delay={item.delay}
                data-wow-duration="1500ms"
                key={item.id}
              >
                <div className="siw-pricing-hex-card">
                  <div className="siw-pricing-hex-price">
                    <p className="siw-pricing-plan-name">{item.planName}</p>

                    <h3>{item.monthly}</h3>
                    <p className="siw-pricing-discount">
                      <span className="siw-pricing-old-price">
                        {item.oldPrice}
                      </span>{" "}
                      50% OFF
                    </p>

                    <p className="siw-pricing-monthly">{item.amount}</p>
                  </div>

                  <div className="siw-pricing-hex-body">
                    <div className="siw-pricing-hex-body-content">
                      <div className="siw-pricing-hex-intro">
                        <p>{item.bestFor}</p>
                        <h5>{item.title}</h5>
                      </div>

                      <h6>WHAT&apos;S INCLUDED</h6>

                      <ul>
                        {item.features.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="siw-pricing-hex-icon">
                    <i className="icon-16"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="container">
        <p className="siw-pricing-note">
          <strong>*</strong>All plans require a minimum 12-month contract.
        </p>
      </div>

      <section className="siw-pricing-extra-section">
        <div className="auto-container">
          {/* Subscription tiers */}
          <div className="siw-subscription-block">
            <h2>WhatsApp Marketing tiers</h2>

            <div className="siw-subscription-table-wrap">
              <table className="siw-subscription-table">
                <thead>
                  <tr>
                    <th>Price</th>
                    <th>WhatsApp Marketing</th>
                    <th>Support</th>
                    <th>Integrations</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>$30</td>
                    <td>~100 messages</td>

                    <td>✓</td>
                    <td>—</td>
                  </tr>

                  <tr>
                    <td>$300</td>
                    <td>~1,000 messages</td>

                    <td>✓</td>
                    <td>—</td>
                  </tr>

                  <tr>
                    <td>$900</td>
                    <td>~3,000 messages</td>

                    <td>✓</td>
                    <td>✓</td>
                  </tr>

                  <tr>
                    <td>Custom</td>
                    <td>Custom volume</td>

                    <td>✓</td>
                    <td>✓</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Guarantee cards */}
          <div className="siw-guarantee-grid">
            <div className="siw-guarantee-card">
              <div className="wafod-feature-icon">
                <i className="bi bi-shield-check"></i>
              </div>

              <div>
                <h3>Quality guarantee.</h3>
                <p>
                  Your AI replies are monitored for quality, accuracy, and
                  consistency based on your business standards. We fine-tune the
                  agent to improve performance over time.
                </p>
              </div>
            </div>

            <div className="siw-guarantee-card">
              <div className="wafod-feature-icon">
                <i className="bi bi-activity"></i>
              </div>

              <div>
                <h3>Live usage dashboard.</h3>
                <p>
                  Track conversations, usage, customer requests, and automation
                  performance so you clearly understand what you are paying for.
                </p>
              </div>
            </div>
          </div>

          {/* Savings section */}
          <div className="siw-savings-block">
            <h2>Estimate how much you can save every year.</h2>

            <p className="siw-savings-subtitle">
              A simple projection of the time and cost your business can reduce
              when your AI agent takes over routine customer conversations.
            </p>

            <div className="siw-savings-card">
              <p>ANNUAL SAVINGS</p>

              <h3>
                {savingsData[activeSaving].annual} <span>/year</span>
              </h3>

              <h5>{savingsData[activeSaving].monthly}</h5>

              <p className="siw-savings-desc">
                {savingsData[activeSaving].desc}
              </p>

              <div className="siw-savings-tags">
                {Object.keys(savingsData).map((key) => (
                  <button
                    type="button"
                    key={key}
                    className={activeSaving === key ? "active" : ""}
                    onClick={() => setActiveSaving(key)}
                  >
                    {savingsData[key].label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className=" mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FooterOne />
    </>
  );
};

export default Pricing;
